module.exports = __webpack_public_path__ + "img/warning.aef9751b.svg";